import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const SocialLinksWrapper = styled.div`
  flex: 1;
`;

export const SocialLink = styled.a`
  font-size: ${({ theme }) => theme.fontSize.large.desktop};
  position: relative;
  top: -5px;
  cursor: pointer;
  margin-right: 20px;

  ${mediaMaxWidth.tablet} {
    font-size: ${({ theme }) => theme.fontSize.large.mobile};
  }
`;

export const FontAwesome = styled.i`
  color: #828282;

  &:hover {
    color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const GlassdoorLink = styled.a`
  cursor: pointer;
  width: 26px;
  position: relative;
  top: -12px;
`;

export const GlassdoorIcon = styled.img`
  width: 26px;
`;
